import React, { useState } from 'react';
import { Link } from 'gatsby';

import Container from './Container';
import Logo from './svg/Logo';

const TopNavLink = ({ href, label, onClick }) => (
  <Link className="text-base text-white font-bold nav-link" to={href} onClick={onClick}>
    {label}
  </Link>
);

const MobileNavLink = ({ href, label, onClick }) => (
  <Link
    className="block px-4 py-3 text-2xl text-white hover:font-bold hover:text-white no-underline"
    activeClassName="font-bold"
    to={href}
    onClick={onClick}
  >
    {label}
  </Link>
);

const MobileNavToggle = ({ isOpen = false, onClick = () => {} }) => (
  <button
    x-ref="navigationOpen"
    type="button"
    className="flex lg:hidden items-center px-2.5 py-2 transition duration-200 hover:text-gray-900 hover:bg-gray-100 hover:border-opacity-100 focus:text-gray-600 focus:bg-gray-200 focus:outline-none focus:ring"
    onClick={() => onClick()}
    aria-label="Open / Close Mobile Navigation Menu"
  >
    <span className="sr-only">Open main menu</span>
    {!isOpen && (
      <svg className="block h-8 w-8" width="28" height="21" viewBox="0 0 28 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="26" height="3" fill="white" />
        <rect x="8" y="9" width="19" height="3" fill="white" />
        <rect x="3" y="17" width="24" height="3" fill="white" />
      </svg>
    )}
    {isOpen && (
      <svg
        className="h-8 w-8"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="white"
        aria-hidden="true"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    )}
  </button>
);

const Nav = () => {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  const mobileNavDisplay = isMobileNavOpen ? 'block' : 'hidden';

  const toggleNav = () => {
    setIsMobileNavOpen(!isMobileNavOpen);
  };

  const closeNav = () => {
    if (isMobileNavOpen) {
      setIsMobileNavOpen(false);
    }
  };

  return (
    <>
      <nav className="sticky top-0 bg-sp-primary py-1 sm:py-3 lg:py-5 xl:py-6 z-50">
        <Container>
          <div className="flex items-center justify-between content-end">
            <Link to="/" className="inline-flex items-center" onClick={closeNav} aria-label="Subscribe Pro Home">
              <Logo className="w-auto h-7 fill-gray-100 hover:fill-white transition" />
            </Link>

            <div className="hidden lg:flex lg:space-x-6 lg:items-center">
              <TopNavLink label="Features" href="/features" />
              <TopNavLink label="Integrations" href="/integrations" />
              <TopNavLink label="Pricing" href="/pricing" />
              <TopNavLink label="Clients" href="/clients" />
              <TopNavLink label="About" href="/about" />
              <Link className="btn btn-sp-pastel" to="/request-demo">
                Book a demo
              </Link>
            </div>

            <MobileNavToggle isOpen={isMobileNavOpen} onClick={toggleNav} />
          </div>
        </Container>
      </nav>

      <div className={`${mobileNavDisplay} fixed w-full h-full top-0 left-0 z-40`}>
        <nav
          className="w-full h-full bg-sp-primary transition-opacity duration-500"
          style={{ opacity: isMobileNavOpen ? '1' : '0' }}
        >
          <div className="pt-[6rem]" id="mobile-menu">
            <div className="py-[2rem] px-2 pb-3 space-y-1">
              <MobileNavLink label="Home" href="/" onClick={closeNav} />
              <MobileNavLink label="Features" href="/features" onClick={closeNav} />
              <MobileNavLink label="Integrations" href="/integrations" onClick={closeNav} />
              <MobileNavLink label="Pricing" href="/pricing" onClick={closeNav} />
              <MobileNavLink label="Clients" href="/clients" onClick={closeNav} />
              <MobileNavLink label="About" href="/about" onClick={closeNav} />
              <div className="pt-12 px-2">
                <Link className="btn btn-lg btn-sp-pastel" to="/request-demo" onClick={closeNav}>
                  Book a demo
                </Link>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Nav;
